<template>
  <div 
    class="pagenation-wrap"
    ref="wrap">
    <el-pagination
      :page-count="5"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="current"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :layout="layoutStr"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import { scrollTo } from '@/utils'
export default {
  data () {
    return {
    }
  },
  computed: {
    current: {
      get(){
        return this.currentPage;
      },
      set(val){
        this.$emit('update:currentPage', val);
      }
    },
    layoutStr(){
      if(!this.layout)
        return 'prev, pager, next, total';
      let splitStr = this.layout.replace(/\s+/g, '').split(',');
      if(this.layoutJumper && splitStr.indexOf('jumper') == -1) splitStr.push('jumper');
      return splitStr.join(', ');
    }
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50]
    },
    layout: String,
    layoutJumper: Boolean,
    total: {
      type: Number,
      default: 0
    },
    targetDom: String
  },
  methods: {
    sizeChangeHandle(size){
      this.$emit('change', page);
      this.scrollHandle();
    },
    currentChangeHandle(page){
      this.current = page;
      this.$emit('change', page);
      this.scrollHandle();
    },
    scrollHandle(){
      let [ target ] = document.getElementsByClassName(this.targetDom);
      if(!target) return;
      
      let offsetTop = target.offsetTop - 20;
      setTimeout(() => scrollTo(offsetTop), 500);
    },
    customStyle(){
      if(this.$refs.wrap){
        let wrap = this.$refs.wrap;
        let [ nextBtn ] = wrap.getElementsByClassName('btn-next');
        let [ total ] = wrap.getElementsByClassName('el-pagination__total');
        this.insertNewline(nextBtn);
        this.insertNewline(total);
      }
    },
    insertNewline(dom){
      if(!dom) return;
      let parent = dom.parentNode;
      let br = document.createElement('br');
      parent.insertBefore(br, dom.nextSibling);
    }
  },
  mounted(){
    this.customStyle();
  }
}
</script>

<style lang="scss" scoped>
.pagenation-wrap{
  display: flex;
  justify-content: center;
  margin: 2.625rem 0 0.525rem;

  .el-pagination{
    text-align: center;

    >>> .el-pagination__total{
      margin-right: 0;
      line-height: inherit;
      margin-top: 0.525rem;
    }

    >>> .el-pagination__jump{
      margin-left: 0;
    }

    &:after{
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue